export const startSession = context => id => ({
    type: "WITNESS.SESSION.START",
    payload: {id},
    context
});